import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size"];
import SVGTextStyle from './SVGTextStyle';
import SVGWrapper from './SVGWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGText = props => {
  const {
      size
    } = props,
    innerProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(SVGWrapper, {
    size: size,
    children: /*#__PURE__*/_jsx(SVGTextStyle, Object.assign({}, innerProps))
  });
};
export default SVGText;